import { Injectable } from '@angular/core';
import {settings} from "../settings/settings";
import {io, Manager} from "socket.io-client";
import {AuthenticationService} from "../auth/services/authentication.service";
import {Socket} from "socket.io-client";
import {generateUUID} from "three/src/math/MathUtils.js";
import {IHasSocket} from "./i-has-socket";
import {Store} from "@ngrx/store";
import {networkActions} from "../state/network/network.actions";
import {worldActions} from "../state/world/world.actions";
import {BehaviorSubject, delay, Subject} from "rxjs";
import {DoWhenReadyService, Readyables} from "./do-when-ready.service";
import * as networkSelectors from "../state/network/network.selector";

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  manager: Manager
  clientId: string
  // eventsSocket: Socket
  lastPingedAt = Date.now();
  lastPingResponseAt = Date.now();
  debug = false

  chatsSocket: BehaviorSubject<Socket> = new BehaviorSubject<Socket>(null)
  reactionsSocket: BehaviorSubject<Socket> = new BehaviorSubject<Socket>(null)
  eventsSocket: BehaviorSubject<Socket> = new BehaviorSubject<Socket>(null)
  filesSocket: BehaviorSubject<Socket> = new BehaviorSubject<Socket>(null)
  usersSocket: BehaviorSubject<Socket> = new BehaviorSubject<Socket>(null)

  constructor(
      private authService: AuthenticationService,
      private store: Store,
      private doWhenReady: DoWhenReadyService
  ) {
    this.clientId = generateUUID()
    this.store.dispatch(worldActions.setDebugValue({
      key: "clientId",
      value: this.clientId
    }))
    let wsProto = "ws"
    if (settings.apiTls) {
      wsProto = "wss"
    }
    let wsUrl = `${wsProto}://${settings.apiHost}:${settings.apiPort}`
    const manager = new Manager(wsUrl, {
      transports: ["websocket"],         // avoid polling split connections
      path: "/ws/socket.io/",
      withCredentials: true,             // if cookies used
      reconnection: true,
      multiplex: true
    });
    this.manager = manager
    this.doWhenReady.everyTime(this, [Readyables.auth], async (user) => {
      if (!user) return
      this.store.select(networkSelectors.selectNetworkEnabled).subscribe(async (startNetwork) => {
        if (!startNetwork) return
        await this.createNewSockets()
      })
    })
  }

  async createNewSockets() {
    const socketMap = {
      "": this.eventsSocket,
      "chats": this.chatsSocket,
      "reactions": this.reactionsSocket,
      "files": this.filesSocket,
      "users": this.usersSocket
    }
    const token = this.authService.getAuthenticationToken()
    for (let subject of Object.values(socketMap)) {
      if (!subject.value) continue
      debugger;
      subject.value.disconnect()
      subject.value.close()
    }
    for (let key of Object.keys(socketMap)) {
      const newSocket = this.manager.socket("/" + key, {
        auth: {
          Authorization: `Bearer ${token}`,
          ClientId: this.clientId
        }
      })
      newSocket.connect()
      newSocket.on("connect", () => {
        this.onConnect(key)
      })
      newSocket.on("disconnect", () => {
        this.onDisconnect(key)
      })
      newSocket.disconnect()
      socketMap[key].next(newSocket)
    }
    this.setupEventPing()
    this.setupPingCheck()
  }

  onConnect(namespace: string) {
    console.log('[WebsocketService] NS (' + namespace + `) connected`)
    this.store.dispatch(networkActions.socketConnected({
      namespace: namespace,
      connected: true
    }))
  }

  onDisconnect(namespace: string) {
    console.log('[WebsocketService] NS (' + namespace + `) disconnected`)
    this.store.dispatch(networkActions.socketConnected({
      namespace: namespace,
      connected: false
    }))
  }

  // namespaceSocket(socketImplementor: IHasSocket) {
  //   let socket: Socket
  //   const token = this.authService.getAuthenticationToken()
  //   socket = this.manager.socket("/" + socketImplementor.namespace, {
  //     auth: {
  //       Authorization: `Bearer ${token}`,
  //       ClientId: this.clientId
  //     }
  //   })
  //   socket.connect()
  //   socket.on("connect", () => {
  //   })
  //   socket.on("disconnect", () => {
  //     console.log(socketImplementor.namespace + ` disconnected`)
  //     this.store.dispatch(networkActions.socketConnected({
  //       namespace: socketImplementor.namespace,
  //       connected: false
  //     }))
  //   })
  //   socket.onAny((event) => {
  //    this.log("event: " + socketImplementor.namespace + " " + event)
  //   })
  //   socket.disconnect()
  //   if (socketImplementor.namespace == "") {
  //   }
  //   return socket
  // }

  log(message: string) {
    if (this.debug) {
      console.log(message)
    }
  }

  pingCheckInterval: any = null
  eventPingInterval: any = null

  setupPingCheck() {
    clearInterval(this.pingCheckInterval)
    this.pingCheckInterval = setInterval(() => {
      const duration = Math.abs(this.lastPingResponseAt - this.lastPingedAt)
      if (duration > 3000) {
        this.store.dispatch(networkActions.markNoResponse({isNoResponse: true}))
      } else {
        this.store.dispatch(networkActions.markNoResponse({isNoResponse: false}))
      }
    }, 2000);
  }

  setupEventPing() {
    clearInterval(this.eventPingInterval)
    this.eventPingInterval = setInterval(() => {
      const start = Date.now();
      if (!this.eventsSocket.value.connected) {
        return;
      }
      this.lastPingedAt = Date.now()
      this.eventsSocket.value.emit("ping", () => {
        const duration = Date.now() - start;
        this.lastPingResponseAt = Date.now();
        this.log(`[WebsocketService] latency: ${duration}`);
        const slowThresholdMs = 100
        if (duration >slowThresholdMs) {
          this.store.dispatch(networkActions.markSlow({isSlow: true}))
        }
        if (duration<= slowThresholdMs) {
          this.store.dispatch(networkActions.markSlow({isSlow: false}))
        }
      });
    }, 1000);
  }

}
